module.exports = __webpack_public_path__ + "static/media/menu-mobile-icon.93453429.svg";